import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReferFriendRoutingModule } from './refer-friend-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ReferFriendRoutingModule
  ]
})
export class ReferFriendModule { }
